import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CaseDetails } from '../details/details.component';
import * as api from '../../shared/api/apihandler';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedDataService } from '../../shared/services/shared-data.service';
import { BookingOnCase } from '../details/models';
import { CompanyService, CompanySettings } from 'app/shared/services/company.service';
import { Section } from 'app/shared/models/standard.models';

export class JubloMessengerHelper {

  content = new MessageContent();
  filterString = '';
  standardTexts;
  showStandardTexts: boolean = false;
  companyUsers;
  useSimplifiedScores: boolean = false;
  useOneToFiveScores: boolean = false;

  constructor(private sanitizer: DomSanitizer, private sharedData: SharedDataService, private company: CompanyService) {
    this.sharedData.companyUsers().subscribe(data => { this.companyUsers = data.filter(x => !!x.name).map(x => x.name); });
    this.company.companySettings().subscribe({
      next: (data: CompanySettings) => {
        if (!!data) {
          let a = data.settings.find((x: Section) => x.companyKeyValuePairSettingsId == '783f5a15-5ba0-4044-ab82-9cbfc39e1c35');
          this.useSimplifiedScores = !!a ? JSON.parse(a.value) : false;
          let b = data.settings.find((x: Section) => x.companyKeyValuePairSettingsId == '4e0a9f75-8cf4-4fc3-bb81-7ab4512b664f');
          this.useOneToFiveScores = !!b ? JSON.parse(b.value) : false;
        }
      }
    });
  }

  cleanMessages(m) {
    for (let i of m) {
      if (i.messageTypeId == '1f960a12-f5a8-4cd3-a474-bb41fd68a026') {
        //Rating
        let parts = i.description.split("Rating: ")[1].split("\r\n");
        let score = parseInt(parts[0], 10);
        let rating = score.toString();
        let restOfDescription = parts[1];
        if (this.useOneToFiveScores) {
          rating = score > 0 ? Math.round(score / 2).toString() : '1';
        } else if (this.useSimplifiedScores) {
          rating = score > 8 ? '😀' : score > 6 && score < 9 ? '😐' : '☹️';
        }
        i.description = "Rating: " + rating + '<br>' + restOfDescription;
      } else {
        if (!!i.description) {
          if (i.description.includes('href="https://case.jublo')) {
            var link = i.description.indexOf('href="https://case.jublo');
            var start = i.description.slice(0, link).lastIndexOf('<a');
            var stop = i.description.slice(start, i.description.length).indexOf('a>');
            i.description = i.description.slice(0, start) + i.description.slice((stop + start) + 2, i.description.length);
          }
          if (i.description.includes('href="https://app.jublo')) {
            var link = i.description.indexOf('href="https://app.jublo');
            var start = i.description.slice(0, link).lastIndexOf('<a');
            var stop = i.description.slice(start, i.description.length).indexOf('a>');
            i.description = i.description.slice(0, start) + i.description.slice((stop + start) + 2, i.description.length);
          }
          if (i.description.includes('https://jubloapi.azure-api.net')) {
            var link = i.description.indexOf('https://jubloapi.azure-api.net');
            var start = i.description.slice(0, link).lastIndexOf('<img');
            var stop = i.description.slice(start, i.description.length).indexOf('/>');
            i.description = i.description.slice(0, start) + i.description.slice((stop + start) + 2, i.description.length);
          }
          if (!!i.shortDescription && i.shortDescription.includes('https://case.jublo')) {
            let start = i.shortDescription.indexOf('https://case.jublo');
            let stop = i.shortDescription.slice(start, i.shortDescription.length).indexOf(' ');
            i.shortDescription = i.shortDescription.slice(0, start) + '\n\n' + i.shortDescription.slice((start + stop), i.shortDescription.length);
          }
          if (!!i.shortDescription && i.shortDescription.includes('https://app.jublo')) {
            let start = i.shortDescription.indexOf('https://app.jublo');
            let stop = i.shortDescription.slice(start, i.shortDescription.length).indexOf(' ');
            i.shortDescription = i.shortDescription.slice(0, start) + '\n\n' + i.shortDescription.slice((start + stop), i.shortDescription.length);
          }
          if (!!i.shortDescription && i.shortDescription.includes('https://applicationv2.azurewebsites')) {
            let start = i.shortDescription.indexOf('https://applicationv2.azurewebsites');
            let stop = i.shortDescription.slice(start, i.shortDescription.length).indexOf(' ');
            i.shortDescription = i.shortDescription.slice(0, start) + '\n\n' + i.shortDescription.slice((start + stop), i.shortDescription.length);
          }
          if (i.description.includes('@')) {
            for (let x of this.companyUsers) {
              if (i.description.includes('@' + x)) {
                i.description = i.description.split('@' + x).join('<span style="font-weight: bold; color: #007bff">@' + x + '</span>')
              }
            }
          }
          i.description = i.description.replace('<a', '<a class="messageLink" style="color:inherit" target="_blank"');
          i.description = i.description.replace('<p></p>','').replace('</p><br><p>','');
          i.description = i.description.split('\n\n').join('<br>').split('\n').join('<br>');
          i.description = i.description.replace('</p><br><p>','<br>');
          i.description = i.description.replace('<br><br>','<br>');
          i.description = i.description.replace('<br /><br />','<br>');
          //i.description = this.sanitizer.bypassSecurityTrustHtml(i.description);
        }
        if (!!i.shortDescription) {
          if (i.shortDescription.includes('@')) {
            for (let x of this.companyUsers) {
              if (i.shortDescription.includes('@' + x)) {
                i.shortDescription = i.shortDescription.split('@' + x).join('<span style="font-weight: bold; color: #007bff">@' + x + '</span>')
              }
            }
          }
          i.shortDescription = !!i.shortDescription ? this.sanitizer.bypassSecurityTrustHtml(i.shortDescription.split('\n\n').join('<br><br>').split('\n').join('<br>')) : null;
        }
      }
    }
    return m.sort((a, b) => a.sentAt < b.sentAt ? -1 : 1).reverse();
  }

  validateCaseMessaging(c: CaseDetails, notificationReciever: string) {
    let check = {
      customer: !!c.customer && (!!c.customer.email || !!c.customer.mobile),
      invoice: !!c.invoice && (!!c.invoice.email || !!c.invoice.mobile),
      delivery: !!c.deliveryAddress && (!!c.deliveryAddress.email || !!c.deliveryAddress.mobile),
      contact: !!c.contactAddress && (!!c.contactAddress.email || !!c.contactAddress.mobile)
    }
    return { ...check, current: check[notificationReciever] }
  }

  resetMessage() {
    this.content = new MessageContent();
  }

  getVisibleMessages(): HTMLElement[] {
    return Array.from(document.getElementById('CaseMessageHolder').childNodes).filter(x => x.nodeName != '#comment') as HTMLElement[]
  }

  filterVisibleByString(s: string) {
    if (!!s) {
      return this.getVisibleMessages().filter(x => x.innerText.toLowerCase().match(s.toLowerCase())).map(x => x.id)
    }
    else return []
  }

  removeFile(index) {
    this.content.files.splice(index, 1);
  }

  hasSpecialMessage(x) {
    return ['77e3ae35-6955-4fbb-89a9-1992ee407dd6', '04630a3b-6f6e-4c24-be3a-f56a0499c8c4'].includes(x.messageTypeId)
  }

  getRating(s) {
    if (!!s && !!s.changingThisBreaksApplicationSecurity && s.changingThisBreaksApplicationSecurity.includes('<br>') && s.changingThisBreaksApplicationSecurity.split('<br>')[0].includes(':')) {
      return +s.changingThisBreaksApplicationSecurity.split('<br>')[0].split(':')[1].trim();
    } else if (!!s && s.includes('<br>') && s.split('<br>')[0].includes(':')) {
      return +s.split('<br>')[0].split(':')[1].trim();
    }
    else return '';
  }

  getRatingStyle(s) {
    let r: number;
    r = +this.getRating(s);
    return r >= 9 ? 'badge-success' : r < 7 ? 'badge-danger' : 'badge-warning';
  }

  getRatingMessage(s) {
    if (!!s && !!s.changingThisBreaksApplicationSecurity && s.changingThisBreaksApplicationSecurity.includes('<br>')) {
      return s.changingThisBreaksApplicationSecurity.split('<br>').slice(1).join('<br>');
    } else if (!!s && s.includes('<br>')) {
      return s.split('<br>').slice(1).join('<br>');
    }
    else return s
  }

  prepareMessageToPartner(message) {
    let ta = document.getElementById('forwardMessageToPartnerText') as HTMLTextAreaElement;
    ta.value = !!message.shortDescription ? message.shortDescription.replace(/<br *\/?>/gi, '\n') : message.description.replace(/<br *\/?>/gi, '\n');
  }

  resendMessage(message) {
    let x = document.getElementById('newMessageText') as HTMLTextAreaElement;
    x.style.height = '40px'; // reset height of area in case of multiple resends
    if (!!message.shortDescription && !!message.shortDescription.changingThisBreaksApplicationSecurity) {
      x.value = message.shortDescription.changingThisBreaksApplicationSecurity.split('<br />').join('\n').split('<br>').join('\n').split('<p>').join('').split('</p>').join('');
    } else if (!!message.shortDescription) {
      x.value = message.shortDescription.split('<br />').join('\n').split('<br>').join('\n').split('<p>').join('').split('</p>').join('');
    } else if (!!message.description && !!message.description.changingThisBreaksApplicationSecurity) {
      x.value = message.description.changingThisBreaksApplicationSecurity.split('<br />').join('\n').split('<br>').join('\n').split('<p>').join('').split('</p>').join('');
    } else if (!!message.description) {
      x.value = message.description.split('<br />').join('\n').split('<br>').join('\n').split('<p>').join('').split('</p>').join('');
    } else {
      x.value = '';
    }
    setTimeout(() => x.style.height = x.scrollHeight + 20 + 'px', 300);
  }

  extractMessage(message){
    let div = document.createElement('div');
    if (!!message.shortDescription && !!message.shortDescription.changingThisBreaksApplicationSecurity) {
      div.innerHTML = message.shortDescription.changingThisBreaksApplicationSecurity.split('<br />').join('\n').split('<br>').join('\n').split('<p>').join('').split('</p>').join('');
      return div.innerText;
    }
    else if (!!message.shortDescription) {
      div.innerHTML = message.shortDescription.split('<br />').join('\n').split('<br>').join('\n').split('<p>').join('').split('</p>').join('');
      return div.innerText;
    }
    else if(!!message.description) { 
      div.innerHTML = message.description.split('<br />').join('\n').split('<br>').join('\n').split('<p>').join('').split('</p>').join('');
      return div.innerText;
    }
    else {
      return ''
    }
  }
}


class MessageContent {
  text: string = '';
  files: any[] = [];
}

export class JubloMessageTypes {
  private checkTypes = ['internal', 'customer', 'company', 'system', 'systemInternal', 'offerAccept', 'partner'];
  private internal = ['5bd55f91-ae0b-4289-911d-a4037a244360'];
  private customer = [
    //'b493822e-bae1-4e96-889c-ae5f821c6473', WebServiceRequest
    '89a873df-acda-41ca-a680-c40f20f7329e',
    'd8e8ed6f-8582-4f0a-bc26-1307f32825ed',
    '77e3ae35-6955-4fbb-89a9-1992ee407dd6',
    '758a738b-e5db-4169-b1b8-63b6fdeff9b7'];
  private offerAccept = ['04630a3b-6f6e-4c24-be3a-f56a0499c8c4'];
  private system = [
    'b2114c29-d297-4a12-bda5-a400fbcaaf40',
    '1aabee02-1576-4dad-a995-3e8c272f8e82',
    '87806a15-0ae5-44a9-ba2e-ff2402b1345f',
    'c2de85a8-7ce7-4e1c-a229-5279e4ea5f2b',
    '8c300432-6ff5-4e6a-a259-1fb0e9877cbf',
    '8850aee1-48a3-48a6-aa98-2e1597b7b1d7',
    '99bc09b6-b7f7-46c0-a40b-5dfc27ec9cf0',
    '7bccdf15-ad49-4cc9-b358-68e08287f32f',
    'b56c96f0-0e8c-4a9f-8faf-70eea6f6b0b7',
    '6bef49c6-c9a1-4fd3-ae13-e9b28dfc7b6b',
    '7f42fb44-d8ea-491f-8bfc-0b63a5276ddf',
    'affa0591-e431-4543-a005-9200d71e5948',
    '69d4f294-ca74-4df1-b018-2e2779e775c5',
    '8c0e89f8-0186-4ded-96a1-806fa7846523',
    'd9cac90c-6aff-4067-8666-a61d07077379',
    '1f960a12-f5a8-4cd3-a474-bb41fd68a026',
    '47324550-1525-4d66-b975-f8c9c9301b15',
    'f92ed551-b7f5-49f8-8d76-e35fcefe33cd',
  ];
  private systemInternal = [
    'dbe287c5-6011-47f3-88e8-eafa671d1ed6'
  ];
  private company = [
    'c3affd15-1834-44ff-9c5e-11763e6aabed',
    'e16ffab0-bbac-4a90-906c-27ec935deba4',
    '880a69de-65ea-4bd0-96bb-238999075b5b',
    '403358d3-f766-43c6-aa19-276c40c9cf5a',
    'a693c47f-9685-4bb6-bf6e-bcab86cb88de',
    '6deaca71-b600-4f4a-8923-3e5286190f4a'];

  private partner = ['7cb47e5a-c66a-4198-8545-a97e9c285dd3'];

  customerCanRead(id) {
    return [
      'd8e8ed6f-8582-4f0a-bc26-1307f32825ed',
      '77e3ae35-6955-4fbb-89a9-1992ee407dd6',
      '8c300432-6ff5-4e6a-a259-1fb0e9877cbf',
      '880a69de-65ea-4bd0-96bb-238999075b5b',
      '403358d3-f766-43c6-aa19-276c40c9cf5a',
      '8850aee1-48a3-48a6-aa98-2e1597b7b1d7',
      '69d4f294-ca74-4df1-b018-2e2779e775c5',
      '6deaca71-b600-4f4a-8923-3e5286190f4a',
      '99bc09b6-b7f7-46c0-a40b-5dfc27ec9cf0',
      '7bccdf15-ad49-4cc9-b358-68e08287f32f',
      'b56c96f0-0e8c-4a9f-8faf-70eea6f6b0b7',
      '8c0e89f8-0186-4ded-96a1-806fa7846523',
      'affa0591-e431-4543-a005-9200d71e5948',
      'b493822e-bae1-4e96-889c-ae5f821c6473',
      '1f960a12-f5a8-4cd3-a474-bb41fd68a026',
      'a693c47f-9685-4bb6-bf6e-bcab86cb88de',
      '89a873df-acda-41ca-a680-c40f20f7329e',
      '04630a3b-6f6e-4c24-be3a-f56a0499c8c4',
      '47324550-1525-4d66-b975-f8c9c9301b15'].includes(id);

  }

  getMessageType(id) {
    for (let x of this.checkTypes) {
      if (this[x].includes(id)) { return x }
    }
  }

  notificationTypeTranslate(id) {
    switch (id) {
      case ('07bbe04a-fc41-4e01-8831-00392ff631e1'): { return 'Notifications.NewPartnerMessage' }
      case ('7df032fb-75c6-4384-93a3-056996c1a074'): { return 'Notifications.ScalepointCaseCreated' }
      case ('cc939846-ffce-434e-8423-114587f6c7d4'): { return 'Notifications.CaseCanceled' }
      case ('d0ff8ebc-6b01-4cfc-90fd-1614d92d4ceb'): { return 'Message.OfferFollowUp' }
      case ('58f3d949-db34-429a-bb04-2fea87c348de'): { return 'Notifications.OfferAcceptedByCustomer' }
      case ('9f75b785-e76d-4247-89e4-3c31f8d6f76d'): { return 'Notifications.RatingReceived' }
      case ('86fb7c3f-6704-484a-b478-43b69473157b'): { return 'Notifications.PartnerCase' }
      case ('db7c46b6-3ef6-4922-80de-4460a69b076c'): { return 'Notifications.OfferCreated' }
      case ('b9ac873d-4f10-46cc-8266-4af2c6acbc5e'): { return 'Notifications.DayAlert' }
      case ('8eeadf88-dd6d-420e-8836-4e7c9af51586'): { return 'Notifications.CaseWithPackage' }
      case ('8eedbaf4-1be5-47f3-9a48-900072ba77ca'): { return 'Notifications.ServiceRequest' }
      case ('e6b70541-3a69-4713-a26a-925855936d5e'): { return 'Notifications.HourAlert' }
      case ('56efa795-61e1-4bb4-8d6f-9cf827667615'): { return 'Notifications.CaseClosed' }
      case ('5a0b92b0-d144-4caf-8849-a2209cee2368'): { return 'Notifications.OfferExpired' }
      case ('0b07ee1d-d68a-4e0d-a7fe-b03ddd5b20c9'): { return 'Notifications.OfferRejectedByCustomer' }
      case ('67833da1-2374-4f23-9f50-b91c6b745e0b'): { return 'Notifications.CustomerMessage' }
      case ('94614c71-0f17-4424-a874-b9acc9a0c294'): { return 'Notifications.RatingSent' }
      case ('b9670930-dc9d-4e17-b9f0-be1927c983d0'): { return 'Notifications.StatusChanged' }
      case ('58cdaacd-4fd8-4d71-b290-c8b650811158'): { return 'Notifications.NewExecutionTime' }
      case ('c74aca4e-4e85-4b4d-bb6c-c8c43ffa7f62'): { return 'Notifications.OfferSend' }
      case ('52dfa920-a480-453b-b446-cc13c07e0854'): { return 'Notifications.ParterStatusChange' }
      case ('0a4b17bc-077c-4f9b-b730-f38042d93c2d'): { return 'Notifications.NewMessage' }
      case ('2058ac00-7ef5-4934-8bf8-ff4f5580a379'): { return 'Notifications.CaseCreated' }
    }
  }
}

export class JubloMessageApi {
  constructor(private http: HttpClient) { }
  caseMessageFiles(caseId: string) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Website/Case/MessagesFiles?caseId=' + caseId, { headers })
  }

  caseMessages(caseId: string) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Website/Case/CaseMessages?caseId=' + caseId, { headers })
  }

  getPartnerMessages(partnerCaseId: string) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer'), 'Content-Type': 'application/json' });
    return this.http.get(api.jubloApi + 'api/Partner/GetPartnerMessages/' + partnerCaseId, { headers })
  }

  getPendingNotifications(caseId: string) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Notification/GetPendingNotifications/' + caseId, { headers })
  }

  caseMessageRead(caseId: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('bearer') });
    return this.http.post(api.jubloApi + 'api/Website/Case/MessageRead/' + caseId, {}, { headers });
  }

  sendInternalMessage(caseId: string, message: MessageWithoutFile) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer'), 'Content-Type': 'application/json' });
    return this.http.post(api.jubloApi + 'api/Website/Case/' + caseId + '/Message/Add/CompanyOnly', { message: message.message, title: message.title }, { headers });
  }

  blindSendInternalMessage(caseId:string, message: MessageWithoutFile) {
    //console.log(caseId, message);
    this.sendInternalMessage(caseId, message).subscribe(
      {
        next: () => {},
        error: err => console.error(err)
      }
    )
  }

  getCaseSettings(caseId: string) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Website/Case/GetCaseSettings/' + caseId, { headers })
  }

  patchCaseNotificationReciever(caseId: string, type: string) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.patch(api.jubloApi + 'api/Website/Case/NotificationReceiver/' + caseId + '/' + type, {}, { headers })
  }

  sendCompanyOnlyMessage(caseId: string, message: string, files:string[]) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer'), 'Content-Type': 'application/json' });
    return this.http.post(api.jubloApi + 'api/Website/Case/' + caseId + '/Message/Add/CompanyOnly', { message: message, title: "", files: files }, { headers });
  }

  sendMessage(caseId: string, message: string, files: any[]) {
    let m = message.split('\n\n').join('\r\n').split('\n').join('\r\n');
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer'), 'Content-Type': 'application/json' });
    if (!!files && files.length > 0) {
      let inputData = {
        "message": m,
        "title": "",
        "files": files.map(x => x.fileId)
      };
      console.log(inputData);
      return this.http.post(api.jubloApi + 'api/Website/Case/' + caseId + '/Message/Add/With/Attachment', inputData, { headers });
    } else {
      return this.http.post(api.jubloApi + 'api/Website/Case/' + caseId + '/Message/Submit', { "message": message, "title": "" }, { headers });
    }
  }

  sendMessageToPartner(partnerCaseId: string, message, files: any[]) {
    let fi = files.map(x => x.fileId)
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer'), 'Content-Type': 'application/json' });
    return this.http.post(api.jubloApi + 'api/Partner/SendPartnerMessage/' + partnerCaseId, { message: message, files: fi }, { headers });
  }

  sendAlertMessageToStakeholders(data) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer'), 'Content-Type': 'application/json' });
    return this.http.post(api.jubloApi + 'api/Website/Case/AlertMessage', data, { headers });
  }

  sendRequestBookingTime(caseId:string, bookingOnCase: BookingOnCase){
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer'), 'Content-Type': 'application/json' });
    return this.http.post(api.jubloApi + '/api/Website/Case/BookingOnCase/' + caseId, bookingOnCase ,{ headers })
  }

  fileUpload(fileToUpload: any) {
    let input = new FormData();
    input.append("file", fileToUpload);
    let fileAccessId = "4D32156A-20FE-4601-8CC8-0A4711034D6B";
    let path = null;
    return this.http.post(api.jubloApi + 'api/shared/attachments/FileWithPath?fileAccessId=' + fileAccessId + "&path=" + path, input);
  }

  getFromPartnerMessageBadge(caseId: string) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Partner/GetUnreadPartnerMessagesTab/' + caseId, { headers })
  }

  getToPartnersMessageBadges(caseId: string) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/Partner/GetUnreadPartnerMessagesById/' + caseId, { headers })
  }

  getStandardTexts() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.get(api.jubloApi + 'api/CompanySettings/GetCompanySetting/' + '76efc162-03e5-4310-ae04-30c730c557b7', { headers })
  }

  pendingMessageToggle(id: string) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.patch(api.jubloApi + 'api/Notification/SendingToggle/' + id, {}, { headers })
  }

  changePendingMessage(id: string, date: Date) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.put(api.jubloApi + 'api/Notification/ChangePendingNotification', {
      id: id,
      sendingAt: date.toISOString()
    }, { headers })
  }

  caseNotificationToggle(caseId: string, status: boolean) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    if (!status) return this.http.get(api.jubloApi + 'api/Website/CaseNotificationToggle/Disable/' + caseId, { headers })
    else return this.http.get(api.jubloApi + 'api/Website/CaseNotificationToggle/Enable/' + caseId, { headers })
  }

  markAsUnread(messageId: string) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.put(api.jubloApi + 'api/Website/Case/MarkAsUnread/' + messageId, {}, { headers })
  }
}

interface MessageWithoutFile {
  message: string;
  title: string;
}
